import React, { useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { useFormDialogStyles, FormDialogHeader, FormSection } from "../FormDialog";
import SlotPicker from "./SlotPicker";

const WEEKDAYS = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"];

// Remarca um agendamento mantendo serviço e profissional. O backend revalida o
// horário (livre e sem conflito) e move lembrete/feedback pendentes junto.
const RescheduleDialog = ({ appointment, onClose, onDone }) => {
  const classes = useFormDialogStyles();
  const [date, setDate] = useState(
    moment(appointment.startAt).isBefore(moment())
      ? moment().format("YYYY-MM-DD")
      : moment(appointment.startAt).format("YYYY-MM-DD")
  );
  const [slot, setSlot] = useState(null);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!slot) return;
    setSaving(true);
    try {
      const { data } = await api.put(`/appointments/${appointment.id}`, { startAt: slot.startAt });
      toast.success("Agendamento remarcado.");
      onDone(data);
    } catch (err) {
      toastError(err);
    }
    setSaving(false);
  };

  const when = slot ? moment(slot.startAt) : null;

  return (
    <Dialog open onClose={saving ? undefined : onClose} maxWidth="sm" fullWidth classes={{ paper: classes.paper }}>
      <FormDialogHeader
        title="Remarcar agendamento"
        subtitle={`${appointment.contact?.name || "Cliente"} · ${appointment.service?.name || ""} com ${
          appointment.user?.name || ""
        }`}
        onClose={onClose}
        disabled={saving}
      />
      <DialogContent dividers className={classes.content}>
        <FormSection title="Novo dia e horário">
          <SlotPicker
            serviceId={appointment.service?.id || appointment.serviceId}
            userId={appointment.user?.id || appointment.userId}
            date={date}
            onDateChange={(d) => {
              setDate(d);
              setSlot(null);
            }}
            value={slot}
            onChange={setSlot}
          />
          <Typography variant="body2" className={classes.muted}>
            {when
              ? `Novo horário: ${WEEKDAYS[when.day()]}, ${when.format("DD/MM [às] HH:mm")}.`
              : `Horário atual: ${moment(appointment.startAt).format("DD/MM [às] HH:mm")}.`}
          </Typography>
          <Typography variant="caption" className={classes.muted}>
            O cliente não é avisado da mudança. O lembrete e o feedback ainda não enviados acompanham o novo horário.
          </Typography>
        </FormSection>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button className={`${classes.actionButton} ${classes.cancelButton}`} onClick={onClose} disabled={saving}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          disableElevation
          className={classes.actionButton}
          disabled={!slot || saving}
          onClick={submit}
        >
          {saving ? <CircularProgress size={20} color="inherit" /> : "Remarcar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RescheduleDialog;
